export const ABOUT_PAGE_ROOT = 'about-page';
export const GROUP_INFO_CREATED_BY = 'groupInfo-createdBy';
export const GROUP_ACTIVITY_INFO_CARD = 'group-activity-info-card';
